import { Link } from 'gatsby'
import React from 'react'
import Brazil from '../assets/brazil.png'
import rsit from '../assets/rsit.png'
import Logo from '../assets/Logo12.png'
import Insta from '../assets/subIconInsta.png'
import Facebook from '../assets/subIconFacebook.png'
import Twiter from '../assets/subIconTwiter.png'

const Footer = () => {
    return (
        <div className=' container5  lg:flex justify-between font-ronsof-four color-ronsof-one'>
            
             <a href='https://www.ronsof.com'>
                <div className='justify-center py-2 flex mx-4 my-4 '>
                    <img className='w-10  animation-ronsof-one' src={rsit} alt='rsit' />
                    <p className='px-3 text-white'>An Ronsoft iT product</p>
                   
                </div>
            </a>
            <div className='py-3 justify-center flex'>
                <a href='https://www.ronsof.com'>
                    <img className='w-8 mx-4 my-4 animation-ronsof-one' src={Facebook} alt='Facebook' />
                </a>
                <a href='https://www.ronsof.com'>
                    <img className='w-8 mx-4 my-4 animation-ronsof-one' src={Twiter} alt='Twiter' />
                </a>
                <a href='https://www.ronsof.com'>
                    <img className='w-8 mx-4 my-4 animation-ronsof-one' src={Insta} alt='Insta' />
                </a>
            </div>
            
        </div>
      
    )
}
export default Footer